// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentAccepted_container__3lCd0","sectionTitle":"PaymentAccepted_sectionTitle__3o3xf"};